import { render, staticRenderFns } from "./BreakingNewsCard.vue?vue&type=template&id=2fad89f9&scoped=true"
import script from "./BreakingNewsCard.vue?vue&type=script&lang=js"
export * from "./BreakingNewsCard.vue?vue&type=script&lang=js"
import style0 from "./BreakingNewsCard.vue?vue&type=style&index=0&id=2fad89f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad89f9",
  null
  
)

export default component.exports